// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"98ab9a8e","301":"0dcbd2fd"}[chunkId] + ".chunk.js";
};